import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProviderSidebarComponent } from '../../sidebar/provider-sidebar.component';
import { ContributionSetupComponent, ContributionSetupConfig } from '../../../shared/components/contribution-setup/contribution-setup.component';
import { StepperStep } from '../../../shared/components/primeng';

@Component({
  selector: 'app-provider-add-model',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ProviderSidebarComponent,
    ContributionSetupComponent,
  ],
  templateUrl: './add-model.component.html',
  styleUrl: './add-model.component.scss',
})
export class ProviderAddModelComponent {
  config: ContributionSetupConfig = {
    type: 'model',
    routeBase: 'provider/add-contributions/add-model',
    setupTitle: 'Setup your Models',
    titlePlaceholder: 'Enter model title',
    localStorageKey: 'modelFormData',
    stepperSteps: [
      {
        key: 'step1',
        label: 'Setup your models',
      },
      {
        key: 'step2',
        label: 'Enter Metadata',
      },
      {
        key: 'step3',
        label: 'Additional Info',
      },
    ],
    routes: [
      'provider/add-contributions/add-model',
      'provider/add-contributions/add-model/metadata',
      'provider/add-contributions/add-model/additionalInfo'
    ]
  };
}
